import {XIcon} from "@phosphor-icons/react/dist/ssr/X";
import { IconButton, IconButtonProps } from '@mui/material';
import * as React from "react";

export function ModalCloseButton({iconColor = "#000000", ...props}: IconButtonProps & {iconColor?: string}) {
  return <IconButton data-test={'modal-close-button'} {...props}>
    <XIcon size={24} color={iconColor} weight="regular" />
  </IconButton>
}
